const o = "_common_1jsvo_1", n = "_big_1jsvo_16", _ = "_icon_1jsvo_20", t = "_small_1jsvo_28", s = "_buttonText_1jsvo_35", l = "_underlined_1jsvo_38", d = "_link_1jsvo_39", e = "_disabled_1jsvo_52", i = "_button_1jsvo_35", c = "_unstyled_1jsvo_71", a = "_loading_1jsvo_74", j = "_iconLeft_1jsvo_77", u = "_spin_1jsvo_1", v = "_primary_1jsvo_89", p = "_secondary_1jsvo_122", r = "_outline_1jsvo_155", b = "_iconButton_1jsvo_188", f = "_full-width_1jsvo_194", g = "_labelWrapper_1jsvo_197", h = "_labelWrapperFullWidth_1jsvo_212", m = "_noPadding_1jsvo_216", W = "_paddedIconLeft_1jsvo_219", y = "_paddedIconRight_1jsvo_222", k = "_iconRight_1jsvo_229", I = "_label_1jsvo_197", L = "_fake_1jsvo_262", R = {
  common: o,
  big: n,
  icon: _,
  small: t,
  buttonText: s,
  underlined: l,
  link: d,
  disabled: e,
  button: i,
  unstyled: c,
  loading: a,
  iconLeft: j,
  spin: u,
  primary: v,
  secondary: p,
  outline: r,
  iconButton: b,
  "full-width": "_full-width_1jsvo_194",
  fullWidth: f,
  labelWrapper: g,
  labelWrapperFullWidth: h,
  noPadding: m,
  paddedIconLeft: W,
  paddedIconRight: y,
  iconRight: k,
  label: I,
  fake: L
};
export {
  n as big,
  i as button,
  s as buttonText,
  o as common,
  R as default,
  e as disabled,
  L as fake,
  f as fullWidth,
  _ as icon,
  b as iconButton,
  j as iconLeft,
  k as iconRight,
  I as label,
  g as labelWrapper,
  h as labelWrapperFullWidth,
  d as link,
  a as loading,
  m as noPadding,
  r as outline,
  W as paddedIconLeft,
  y as paddedIconRight,
  v as primary,
  p as secondary,
  t as small,
  u as spin,
  l as underlined,
  c as unstyled
};
